var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.701,
    height: 21.995,
    viewBox: "0 0 18.701 21.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 9229",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1351.1 363.743a.448.448 0 0 0-.461-.429 13 13 0 0 1-8.537-2.854.452.452 0 0 0-.584 0 12.985 12.985 0 0 1-8.538 2.854.448.448 0 0 0-.461.429c-.176 4.534-.075 10.291 1.9 13a20.981 20.981 0 0 0 7.394 5.61 21.1 21.1 0 0 0 7.394-5.61c1.971-2.7 2.072-8.461 1.9-13z",
    style: {
      stroke: "none"
    },
    transform: "translate(1369.745 -360.353)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1360.395 362.506c-2.668 1.888-5.554 2.445-7.532 2.576-.051 2.22.006 4.08.174 5.655.309 2.9.942 4.288 1.42 4.943 1.5 2.063 4.525 3.965 5.935 4.692 1.415-.732 4.448-2.642 5.942-4.694.477-.653 1.11-2.041 1.419-4.941.167-1.575.225-3.435.174-5.656-1.978-.13-4.861-.688-7.532-2.575m0-2.153c.104 0 .208.036.292.107 3.078 2.58 6.702 2.888 8.537 2.854a.447.447 0 0 1 .462.43c.175 4.534.074 10.29-1.897 12.995-2.064 2.834-6.385 5.244-7.394 5.61-1.01-.361-5.33-2.772-7.394-5.61-1.972-2.705-2.073-8.461-1.897-12.996a.448.448 0 0 1 .461-.43c1.838.036 5.464-.272 8.538-2.853a.45.45 0 0 1 .292-.107z",
    style: {
      fill: "#254089",
      stroke: "none"
    },
    transform: "translate(1369.745 -360.353)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9230",
    d: "M-1319.553 410.22v2.917a.677.677 0 0 1-.677.677.677.677 0 0 1-.677-.677v-2.917a2.465 2.465 0 0 1-1.764-2.712 2.465 2.465 0 0 1 2.442-2.123 2.466 2.466 0 0 1 2.442 2.123 2.465 2.465 0 0 1-1.765 2.712zm-.677-3.477a1.111 1.111 0 0 0-1.111 1.111 1.111 1.111 0 0 0 1.111 1.111 1.111 1.111 0 0 0 1.111-1.111 1.111 1.111 0 0 0-1.111-1.111z",
    transform: "translate(1329.58 -398.798)",
    style: {
      fill: "#254089"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon);
export default __webpack_public_path__ + "static/media/privacy-icon.3a0fed29213ce867fa73925a2cee8d8c.svg";
export { ForwardRef as ReactComponent };